import questions from './questions.json';

export enum AnswerType {
    IQ = "0",
    Szemelyiseg = "1",
    SzabadSzoveg = "2",
    Skala = "3",
    Szoveg = "4",
    Sor = "5",
}

export interface Question {
    id?: string;
    text: string;
    nextButtonText?: string;
    last?: boolean;
    minLabel?: string;
    maxLabel?: string;
    imageUrl?: string;
    orderNumber?: number;
    type: AnswerType;
    answers?: Answer[];
}

export interface Answer {
    id: string;
    text: string;
    imageUrl: string;
}

export interface QuestionResponse {
    index: number;
    total: number;
    nextQuestions: Question[];
    remainingSeconds?: number;
}

export function getQuestions(): Question[] {
    return questions as Question[];
}
